import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";

const DentalDisciplinesAverageGrades = ({ handleParamChange }) => {
  return (
    <>
      <ReferenceInput
        source="academicYearId"
        reference={studentRequests.getAcademicYearsSelect()}
      >
        <SelectInput
          label="Учебна година"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("academicYearId", e.target.value)}
        />
      </ReferenceInput>
      <ReferenceInput
        source="instructionLanguageId"
        reference={administrationRequests.getInstructionLanguagesSelect()}
      >
        <SelectInput
          label="Език на обучение"
          validate={required()}
          emptyText={false}
          onChange={e => handleParamChange("instructionLanguageId", e.target.value)}
        />
      </ReferenceInput>
    </>
  );
};

export default DentalDisciplinesAverageGrades;
